import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { useState } from 'react';
import {
  postEvaluationImageUrl,
  EvaluationImageUrlPayload,
} from '../reducers/postEvaluationImageUrl';

const usePostEvaluationImageUrl = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<unknown>();

  const postEvaluationImageDetailsResult = async (
    requestPayload: EvaluationImageUrlPayload,
  ) => {
    try {
      const resultAction = await dispatch(postEvaluationImageUrl(requestPayload));
      if (postEvaluationImageUrl.fulfilled.match(resultAction)) {
        setLoading(false);
      }
    } catch (error) {
      setError(error);
    }finally{
      setLoading(false)
    }
  };

  return { loading, error, postEvaluationImageDetailsResult };
};

export default usePostEvaluationImageUrl;
